import { SessionCreateResponse } from "openai/resources/beta/realtime/sessions";
import { safeParse } from "../Util";

export async function initializeRTC(ephemeralToken: SessionCreateResponse.ClientSecret, handlers?: {
  onReady?: () => void,
  onError?: (e: Event) => void,
  onConnectionError?: (errMsg: string) => void,
  onClose?: (e: Event) => void
}) {
  const pc = new RTCPeerConnection();

  // create an empty media stream to satisfy OpenAI
  // that there is an audio input on the client side
  // this is required even when only use text modality
  const destination = new (window.AudioContext || (window as any).webkitAudioContext)().createMediaStreamDestination();
  const emptyMediaStream = destination.stream;
  pc.addTrack(emptyMediaStream.getTracks()[0]);

  const dataChannel = pc.createDataChannel("oai-events");
  const offer = await pc.createOffer();
  await pc.setLocalDescription(offer);

  const baseUrl = "https://api.openai.com/v1/realtime";
  const sdpResponse = await fetch(`${baseUrl}`, {
    method: "POST",
    body: offer.sdp,
    headers: {
      Authorization: `Bearer ${ephemeralToken.value}`,
      "Content-Type": "application/sdp"
    },
  });

  if (handlers?.onReady) {
    dataChannel.onopen = handlers.onReady;
  }

  if (handlers?.onClose) {
    dataChannel.onclose = handlers.onClose;
  }

  if(handlers?.onError) {
    dataChannel.onerror = handlers.onError;
  }

  const sdp = await sdpResponse.text();
  const responseJSON = safeParse(sdp);
  if (responseJSON?.error) {
    handlers?.onConnectionError?.(responseJSON.error?.message || sdp || "Failed to initialize WebRTC chat session");
  } else {
    const answer = {
      type: "answer",
      sdp
    } as const;
    await pc.setRemoteDescription(answer);
  }
  return { pc, dataChannel };
}
